import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import CostingCard from '@components/CostingCard';
import NoData from '@components/NoData';
import { toastError, toastSuccess } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

const CostingList = ({ collectionId }) => {
	const [costingList, setCostingList] = useState([]);
	const dispatch = useDispatch();

	const fetchCostingList = async () => {
		dispatch(openLoader());
		try {
			let { data } = await ApiClient.GET('fetchCollectionWiseCosting', `${collectionId}`);
			setCostingList(data);
			dispatch(closeLoader());
			if (data.success) {
				toastSuccess(data.message);
			}
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.response.data.message);
		}
	};

	useEffect(() => {
		fetchCostingList();
	}, [collectionId]);

	return (
		<div className="sample-dashboard-container costing-tab-container pt-3 bg-gray">
			<div className="sample-items-row">
				{costingList.length === 0 ? (
					<NoData message="No costing found" />
				) : (
					costingList?.map((item) => (
						<Fragment key={item.id}>
							<CostingCard costingItem={item} />
						</Fragment>
					))
				)}
			</div>
		</div>
	);
};

export default CostingList;
